import { Divider, Grid, Typography } from '@mui/material';
import { type ReactNode } from 'react';
import { v4 } from 'uuid';

export type TablelikeRow = [ReactNode, ReactNode];

type TablelikeProps = {
  readonly heading?: ReactNode;
  readonly rows: (TablelikeRow | undefined)[];
  readonly withDivider?: boolean;
  readonly xsLeft?: number;
  readonly pb?: number;
};

export const Tablelike = (props: TablelikeProps) => (
  <Grid container spacing={1} pb={props.pb}>
    {props.heading ? (
      <Grid size={{ xs: 12 }}>
        <Typography variant="headingXxs" component="div">
          {props.heading}
        </Typography>
      </Grid>
    ) : null}
    {props.rows
      .filter((row) => row !== undefined)
      .map(([label, value]) => (
        <Grid key={v4()} container size={{ xs: 12 }}>
          <Grid size={{ xs: props.xsLeft ?? 4 }} sx={{ overflowWrap: 'break-word', textOverflow: 'pretty' }}>
            <Typography component="div" color="textTertiary">
              {label}
            </Typography>
          </Grid>
          <Grid size={{ xs: props.xsLeft ? 12 - props.xsLeft : 8 }} alignItems="center">
            <Typography component="div">{value}</Typography>
          </Grid>
        </Grid>
      ))}
    {props.withDivider ? (
      <Grid size={{ xs: 12 }} sx={{ marginBottom: 2, marginTop: 1 }}>
        <Divider />
      </Grid>
    ) : null}
  </Grid>
);
